<template>
    <component :is="type" :key="configuration.id" :id="configuration.id" :configuration="configuration" />
</template>

<script>
    export default {
        name: 'Components',
        props: {
            configuration: Object
        },
        computed: {
            type(){
                return this.types.hasOwnProperty(configuration.type) ? this.types[configuration.type] : configuration.type;
            }
        },
        data(){
            return {
                types: {
                    image: 'media',
                    embed: 'media'
                }
            };
        },
        methods: {

        }
    }
</script>

<style lang="less">
    @import "~@/assets/less/variables";

    article
    {
        font-style: normal;
        counter-reset: figure example question note simulation;
        color: var(--secondary-text-color);

        p, ul, ol
        {
            margin: 20px 50px;
            line-height: 26px;
            font-size: 16px;

            &:last-child
            {
                margin-bottom: 0;
            }

            h3
            {
                padding: 0;
                margin-bottom: 0;
                font-size: 20px;
                margin-top: 30px;
            }
        }

        ul, ol
        {
            padding-left: 25px;
            list-style: disc;

            li
            {
                margin-bottom: 10px;
            }
        }

        ol
        {
            list-style: decimal;
        }

        h2, h3
        {
            color: #FFF;
            font-weight: 500;
            margin: 50px 50px 10px;
            font-size: 20px;
            line-height: 24px;
        }

        h2
        {
            font-size: 28px;
            font-weight: 600;
            line-height: 36px;
        }

        h3 + p, h3 + ul, h2 + p, h2 + ul
        {
            margin-top: 10px;
        }

        li
        {
            // margin: 30px 50px;
            line-height: 28px;
            font-size: 16px;
        }

        .example.card, .note.card
        {
            counter-increment: example;
            padding-top: 20px;

            h2
            {
                span::before
                {
                    font-weight: 500;
                    color: #FFF;
                    content: counter(example);
                }
            }
        }

        .note.card
        {
            counter-increment: note;

            h2
            {
                span::before
                {
                    content: counter(note);
                }
            }
        }

        figure
        {
            margin: 50px 0;

            &:last-child
            {
                margin-bottom: 0;
            }

            h2
            {
                font-size: 12px;
                color: var(--primary-text-color);
                font-weight: 500;
                margin: 0;
                text-align: center;
            }

            img
            {
                background: #111;
                display: block;
                max-width: 100%;
                min-height: 100px;
                margin: 0 auto;
            }

            figcaption
            {
                font-size: 12px;
                margin: 10px 50px;
                line-height: 18px;
                color: var(--secondary-text-color);
                text-align: center;
            }

            &.simulation-figure
            {
                counter-increment: simulation;

                figcaption
                {
                    .figure-title
                    {
                        &::before
                        {
                            content: "Simulation " counter(simulation) ".";
                        }
                    }
                }
            }

            &.image-figure, &.embed-figure
            {
                counter-increment: figure;

                figcaption
                {
                    .figure-title
                    {
                        &::before
                        {
                            content: "Figure " counter(figure) ".";
                        }
                    }
                }
            }

            table + figcaption
            {
                text-align: center;
            }
        }

        .card
        {
            padding: 30px 0;
            border-radius: 3px;
            border: 2px solid #666;
            margin: 30px 20px;

            &[type="did-you-know"]
            {
                .card-type::after
                {
                    content: "Did You Know";
                }
            }

            &[type="try-this"]
            {
                .card-type::after
                {
                    content: "Try This";
                }
            }
        }

        .question-header, .card-header
        {
            padding: 0 20px;
        }

        .question-type, .question-number, .card-type, .card-number
        {
            font-weight: 500;
            font-size: 14px;
            color: #888;
        }

        .question-number::after
        {
            color: #CCC;
            content: "Question " counter(question);
        }

        .example .card-type::after
        {
            color: #CCC;
            content: "For Example";
        }

        .example .card-number::after
        {
            content: "Example " counter(example);
        }

        .card-contents
        {
            h1:first-child, h2:first-child, h3:first-child
            {
                margin-top: 20px;
            }
        }

        .note
        {
            .card-type::after
            {
                color: #CCC;
            }

            &.link-to-learning
            {
                .card-type::after
                {
                    content: "Link To Learning";
                }
            }

            &.seeing-for-yourself
            {
                .card-type::after
                {
                    content: "Seeing For Yourself";
                }
            }
        }

        .note .card-number::after
        {
            content: "Note " counter(note);
        }

        .question-number, .card-type
        {
            margin-right: 10px;
        }

        .math
        {
            font-size: 18px;
            color: #FFF;
            padding: 20px;
        }

        sup.footnote
        {
            a
            {
                border-bottom: 0;
            }
        }

        em
        {
            font-style: italic;

            &.bold
            {
                font-weight: 700;
                font-style: normal;
            }

            &.italics
            {
                font-style: italic;
            }
        }

        dfn
        {
            border-bottom: 1px dashed #AAA;
            font-style: normal;
        }

        a
        {
            color: #3a9bfc;
            text-decoration: none;
            border-bottom: 1px dashed #3a9bfc;
            cursor: pointer;

            &:hover, &:active
            {
                border-bottom-style: solid;
            }
        }

        sub, sup
        {
            margin-left: 2px;
            font-size: 0.6rem;
        }

        sup
        {
            vertical-align: super;
        }

        sub
        {
            vertical-align: sub;
        }

        em + sub, em + sup
        {
            font-style: italic;
        }

        b, strong
        {
            font-weight: 600;
        }

        table
        {
            margin: 0 auto;
            margin: 30px 50px;

            td
            {
                border-bottom: 1px solid #333;
                padding: 10px 20px 10px 0;

                &[align="center"]
                {
                    text-align: left;
                }

                &[align="left"]
                {
                    text-align: left;
                }

                &[align="right"]
                {
                    text-align: right;
                }

                p
                {
                    margin: 0;
                }
            }

            thead
            {
                td
                {
                    color: var(--primary-text-color);
                    // background: #222;
                }
            }

            tbody
            {
                tr:last-child
                {
                    td
                    {
                        border-bottom: 0;
                    }
                }
            }
        }

        .embed
        {
            padding: 0 20px;
            margin: 30px 0;

            iframe
            {
                border: 0;
            }
        }
    }

    @media only screen and (max-width: 1100px)
    {
        article
        {
            h2, h3
            {
                margin: 30px 30px 10px;
                font-size: 18px;
                line-height: 22px;
            }

            p, ul, ol
            {
                margin: 20px 30px;
                line-height: 20px;
                font-size: 14px;
            }

            figure
            {
                margin: 30px 0;
            }
        }
    }
</style>